import React from 'react'
import i18next from 'i18next'
import { Modal, Button, Badge, Card } from 'react-bootstrap'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import { Trans } from 'react-i18next'
import { format, parseISO } from 'date-fns'
import { getConstants } from 'src/lib/constants'
import AppointmentForm from 'src/components/appointments/appointment_form'

const { t } = i18next

const styles = {
  add_modal: {
    minHeight: '55vh',
  },
  add_table: {
    /* border-bottom: solid 0.15rem var(--bs-primary); */
    boxShadow: 'none',
  },
}
class AppointmentsListModal extends React.Component {
  static defaultProps = {
    business_role_priority: null,
  }
  state = {
    show: false,
    appointments: [],
    dealer: null,
    current_appointment: null,
  }
  appointmentTypes = getConstants().appointment_types
  statuses = getConstants().appointment_statuses

  show = ({ appointments = [], dealer }) => {
    this.setState({ show: true, appointments, dealer })
  }

  hide = () => this.setState({ show: false, appointments: [] })

  renderContractIcon = rowData => {
    const { contract } = rowData

    const status = contract?.status || 'pending'

    let icon_class = 'text-primary '

    if (status === 'signed') {
      icon_class = 'text-success '
    } else if (status === 'expired') {
      icon_class = 'text-dark '
    } else if (status === 'pending') {
      icon_class = 'text-warning '
    } else if (status === 'rejected') {
      icon_class = 'text-danger '
    }

    return (
      <div>
        {contract && (
          <>
            <i role="button" className={`fas fa-file-contract ms-2 ${icon_class}`}></i>
          </>
        )}
      </div>
    )
  }

  renderStatus = ({ status, rejected_note, rejected_at, success_at }) => {
    const statusMap = {
      concluded: { text: this.statuses['concluded'], color: 'success', date: success_at },
      rejected: { text: this.statuses['rejected'], color: 'danger', date: rejected_at },
      pending: { text: this.statuses['pending'], color: 'warning', date: null },
    }

    const { text, color, date } = statusMap[status]

    return (
      <div className="text-center">
        <Badge bg={color} className="px-3 py-2 text-uppercase shadow-sm" style={{ fontSize: '1rem' }}>
          {text}
          {date && (
            <div className="small mt-1">
              <em>{format(parseISO(date), 'dd/MM/yyyy')}</em>
            </div>
          )}
        </Badge>
        {status === 'rejected' && rejected_note && (
          <div className="text-muted small mt-1 px-2">
            <em>{rejected_note}</em>
          </div>
        )}
      </div>
    )
  }

  renderDetails(rowData) {
    const { date, created_by, type, brand_name } = rowData
    let { piva, business_name } = this.state.dealer
    let fullname = created_by ? created_by.first_name + ' ' + created_by.last_name : ''

    return (
      <Card className="shadow-lg border-0 rounded-lg">
        <Card.Body className="pb-2 pt-2">
          <div className="d-flex">
            <Badge bg="primary" className="px-3 py-2 me-2 text-uppercase shadow-sm" style={{ fontSize: '0.8rem' }}>
              {this.appointmentTypes[type]}
            </Badge>
            {this.renderContractIcon(rowData)}
          </div>
          <p className="text-muted mb-1">
            <i className="fas fa-building me-2"></i>
            {business_name} ({piva})
          </p>
          <p className="text-muted mb-1">
            <i className="fas fa-calendar-alt me-2"></i>
            {format(parseISO(date), 'dd/MM/yyyy HH:mm')}
          </p>
          <p className="text-muted mb-1">
            <i className="fas fa-tag me-2"></i>
            {brand_name}
          </p>

          <p className="text-muted mb-1">
            <i className="fas fa-user me-2"></i>
            {fullname}
          </p>

          {this.renderStatus(rowData)}
        </Card.Body>
        <Card.Footer className="text-center bg-light pb-3 pt-3">
          <Button className="btn btn-link p-0" onClick={() => {}}>
            <i className="fas fa-bullseye"></i>
          </Button>
        </Card.Footer>
      </Card>
    )
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: ({ rowData }) => (
        <Button className="btn btn-link p-0" onClick={() => this.setCurrentAppointment(rowData)}>
          <i className="fas fa-eye me-0"></i>
        </Button>
      ),
    },
    {
      name: 'code',
      title: t('components.appointments.code', 'Codice'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      data: ({ rowData }) => rowData.code,
    },
    {
      name: 'type',
      title: t('components.appointments.type', 'Tipo'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      data: ({ rowData }) => {
        return (
          <div className="d-flex flex-row">
            {this.appointmentTypes[rowData.type]} {this.renderContractIcon(rowData)}
          </div>
        )
      },
    },

    {
      title: t('components.appointments.date', 'Data'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },

      data: ({ rowData: { date } }) => {
        return format(parseISO(date), 'dd/MM/yyyy HH:mm')
      },
    },
    {
      title: t('components.appointments.brand', 'Brand'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      data: ({ rowData: { brand_name } }) => {
        return brand_name
      },
    },
    {
      name: 'created_by',
      title: t('components.appointments.created_by', 'Creato da'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      data: ({ rowData: { created_by } }) => {
        let fullname = created_by?.first_name + ' ' + created_by?.last_name
        return fullname
      },
    },
    {
      name: 'status',
      title: t('components.appointments.status', 'Stato'),
      className: 'd-none d-sm-block flex-fill text-center',
      style: { width: '12%' },
      data: ({ rowData }) => this.renderStatus(rowData),
    },
    {
      title: t('components.appointments.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  getColumns = () => {
    return this.columns
  }

  setCurrentAppointment = appointment => {
    const { dealer } = this.state
    let created_by_name = appointment.created_by?.first_name + ' ' + appointment.created_by?.last_name
    let dealer_id = dealer.id
    this.setState({
      current_appointment: {
        ...appointment,
        ...dealer,
        created_by_name,
        dealer_id,
        created_by: appointment?.created_by?.id ?? null,
      },
    })
  }

  closeAppointment = () => {
    this.setState({ current_appointment: null })
  }

  render() {
    const { show, appointments, dealer, current_appointment } = this.state
    const title_appointment_form = `${t('components.appointments.view_appointment', 'Visualizza visita')}: ${
      this.appointmentTypes[current_appointment?.type]
    }`

    return (
      <Modal backdrop="static" centered show={show} onHide={this.hide} size="xl">
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="components.interactive_map.appointments_list_modal.title">
              <b>{dealer?.business_name}</b>({dealer?.piva})
            </Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column flex-fill" style={{ height: '60vh' }}>
          <ResponsiveTable
            className={`flex-fill ${styles.add_table}`}
            data={appointments}
            totalRecords={appointments.length}
            columns={this.getColumns()}
            modalSize="xl"
            dialogClassName="modal-90w"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hide} variant="primary">
            <Trans i18nKey="buttons.close">Chiudi</Trans>
          </Button>
        </Modal.Footer>

        <Modal backdrop="static" centered show={current_appointment !== null} onHide={this.closeAppointment} size="xl">
          <Modal.Header>
            <Modal.Title>{title_appointment_form}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column">
            <AppointmentForm
              appointmentFromProps={current_appointment}
              business_role_priority={this.props.business_role_priority}
              categories={current_appointment?.merchandise_category ? [current_appointment.merchandise_category] : []}
              readonly={true}
              closeForm={this.closeAppointment}
            />
          </Modal.Body>
        </Modal>
      </Modal>
    )
  }
}

export default AppointmentsListModal
